<span class="hover-over">
    <div class="wrapper">
        <h1 class="mat-title">Login</h1>
        <h3 class="sub-title"><!--{{data.header}}-->An account is already registered with your email address. Please
            either login or continue as guest.</h3>

        <div>
            <div class="col-sm-12 row mobile-widener-right">
                <!-- col-md-6  -->
                <div class="col-sm-12 col-lg-6 mt-4 mobile-widener">
                    <div class="card bb-panel">


                        <form [formGroup]="loginForm" autocomplete="chrome-off" (ngSubmit)="onSubmit()"
                            class="col-sm-12">
                            <div class="card-location-header">
                                <h4 class="text-dark"><strong>Login</strong></h4>
                            </div>
                            <div class="form-group">
                                <label tabindex="0">Email</label>
                                <input type="text" class="form-control" formControlName="email" tabindex="0"
                                    role="textbox" (keydown.space)="$event.preventDefault();"
                                    (keydown.spacebar)="$event.preventDefault();">
                                <div *ngIf="submitted && form.email.errors" class="invalid-feedback">
                                    <div *ngIf="form.email.errors.required" role="alert" tabindex="0">Email is
                                        required</div>
                                    <div *ngIf="form.email.errors.pattern" role="alert" tabindex="0">Email must be a
                                        valid email address
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label tabindex="0">Password</label>
                                <input [type]="hide ? 'password' : 'text'" class="form-control"
                                    formControlName="password" tabindex="0" role="textbox">
                                <span class="eye-pos">
                                    <mat-icon class="material-symbols-outlined eye" (click)="togglePasswordVisible()"
                                        *ngIf="hide">
                                        visibility_off
                                    </mat-icon>
                                    <mat-icon class="material-symbols-outlined eye" (click)="togglePasswordVisible()"
                                        *ngIf="!hide">
                                        visibility
                                    </mat-icon>
                                </span>
                                <div *ngIf="submitted && form.password.errors" class="invalid-feedback">
                                    <div *ngIf="form.password.errors.required" role="alert" tabindex="0">Password is
                                        required</div>
                                </div>
                            </div>
                            <div *ngIf="submitted && loginError" class="invalid-feedback">
                                <div role="alert" tabindex="0">Sorry, your email or password was not recognised. Please
                                    try
                                    again or reset your password.
                                </div>
                            </div>
                            <button type="submit" class="btn btn-primary  govuk-button button-sizer btn-max"
                                role="button">
                                <span><span>{{'ACCESS.LOGIN' | translate}}</span>
                                    <fa-icon [icon]="faChevronRight"></fa-icon>
                                </span>
                            </button>

                            <br>
                            <br>
                        </form>

                        <app-reset-password [selectedDepartment]="selectedDepartment"></app-reset-password>
                        <br>
                        <br>
                        <div class="col-sm-12">
                            <button (click)="onNoClick()" class="btn btn-primary  govuk-button button-sizer btn-max"
                                role="button" *ngIf="this.data.continue">
                                <span><span>{{'ACCESS.CONTINUE' | translate}}</span>
                                    <fa-icon [icon]="faChevronRight"></fa-icon>
                                </span>
                            </button>
                        </div>
                        <!-- <span class="govuk-error-message forgot-password col-sm-12" (click)="forgotPasswordToggle()">Forgot
                    your
                    password?</span>

                <form [formGroup]="resetPasswordForm" class="col-sm-12">
                    <fieldset *ngIf="forgotPassword" class="govuk-fieldset">
                        <br />
                        <input class="form-control" id="reset-email-form" name="reset-email-form" type="text"
                            autocomplete="email" placeholder="Enter email address" formControlName="resetemail"
                            tabindex="0" role="textbox">
                        <br />
                        <div *ngIf="resetSubmitted && resetForm.resetemail.errors">
                            <p *ngIf="resetForm.resetemail.errors.pattern" id="email-error" class="invalid-feedback">
                                <span class="govuk-visually-hidden">Error:</span>
                                {{'FORM.EMAIL_INVALID'
                                |
                                translate}}
                            </p>
                            <p *ngIf="resetForm.resetemail.errors.required" id="email-error" class="invalid-feedback">
                                <span class="govuk-visually-hidden">Error:</span>
                                {{'FORM.EMAIL_REQUIRED'
                                |
                                translate}}
                            </p>
                            <br />
                        </div>
                        <button class="btn btn-primary govuk-button button-sizer btn-max" data-module="govuk-button"
                            (click)="sendReset()">
                            <span><span>{{'ACCESS.SENDRESET' | translate}}</span>
                                <fa-icon [icon]="faChevronRight"></fa-icon></span>
                        </button>
                        <br />

                        <span class="invalid-feedback forgot-password-success" *ngIf="resetSuccess">
                            <br />
                            If your email exists, you will receive a password reset email shortly
                        </span>
                    </fieldset>
                </form> -->
                    </div>
                </div>
            </div>
            <hr />

            <!--
        <div mat-dialog-actions class="row">
            <div class="col-sm-6">
                <button (click)="onNoClick()" class="btn btn-primary govuk-button  button-sizer"
                    style="text-align: center;">Close</button>
            </div>
        </div>
        -->
        </div>
    </div>
</span>